var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DiyoboInput',{staticClass:"notranslate",attrs:{"type":"dropdown","name":"language","noLabel":"","placeholder":"Select Language","options":_vm.currentLanguages,"val":_vm.currentLanguage,"language":""},on:{"input":_vm.gTranslate}}),_c('div',{attrs:{"id":"google_translate_element"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }